import {
    FieldPath, FieldValues, RegisterOptions, UseControllerProps
} from 'react-hook-form';


export function addValidationRule<
    TFieldValues extends FieldValues,
    TName extends FieldPath<TFieldValues>
>(
    rules: UseControllerProps<TFieldValues, TName>['rules'],
    rulesToAdd: RegisterOptions<TFieldValues, TName>['validate']
) {
    return {
        ...rules,
        validate: {
            ...rulesToAdd,
            ...(rules?.validate instanceof Function ? {
                validateFunction: rules.validate
            } : rules?.validate)
        }
    };
}
